export interface HomeSettings {
  recommendMenus: [
    {
      details: string;
      id: number;
      maxDishNumber: number;
      coverView: any;
      name: string;
    },
  ];
  recommendDeals: [
    {
      coverView: any;
      description: string;
      expiryDate: string;
      id: number;
      issueDate: string;
      name: string;
      price: string;
      redeemCode: string;
      rule: string;
    },
  ];
  recommendDishes: [
    {
      id: number;
      offeringType: string;
      price: string;
      name: string;
      description: string;
      coverView: any;
    },
  ];
  recommendEvents: [
    {
      id: number;
      startDate: string;
      endDate: string;
      name: string;
      requirement: string;
      description: string;
    },
  ];
}
export default {} as HomeSettings;

export const spaceName = 'caHome';
